import React from "react";

const PageTitle = ({ children }) => {
  return (
    <h2 className="page-title pb-2 mb-4 border-bottom border-2 border-dark">
      {children}
    </h2>
  );
};

export default PageTitle;
